/* eslint-disable no-use-before-define */
const LG_BREAKPOINT_PX = 992;

// Exported so tests can spy on navigation without fighting jsdom's window.location
export const nav = {
  go: (url) => {
    window.location.href = url;
  },
};

const isDesktop = () => window.innerWidth >= LG_BREAKPOINT_PX;

export function initNavSearch() {
  const form = document.querySelector(".topco-nav-search");

  if (!form) return; // <-- ADD THIS LINE

  const toggle = form.querySelector(
    ".topco-nav-search-toggle, .topco-nav-search-submit"
  );
  const container = form.querySelector(".topco-nav-search-container");
  const input = form.querySelector(".topco-nav-search-input");

  if (!toggle || !container || !input) return;

  const toggleIcon = toggle.querySelector("i");

  const isOpen = () => !container.classList.contains("d-none");

  const open = () => {
    if (isDesktop()) return;

    container.classList.remove("d-none");
    container.classList.add("d-flex");

    toggle.setAttribute("aria-expanded", "true");
    if (toggleIcon) {
      toggleIcon.classList.remove("bi-search");
      toggleIcon.classList.add("bi-x-lg");
    }

    // Ensure focus happens after layout is updated.
    window.requestAnimationFrame(() => {
      input.focus();
    });

    document.addEventListener("click", onDocumentClick);
    document.addEventListener("keydown", onDocumentKeydown);
  };

  const close = () => {
    if (isDesktop()) {
      // When switching to desktop, rely on Bootstrap's responsive display
      // utilities and ensure we don't accidentally keep `d-none` around.
      container.classList.remove("d-none");
      container.classList.remove("d-flex");

      toggle.setAttribute("aria-expanded", "false");
      if (toggleIcon) {
        toggleIcon.classList.remove("bi-x-lg");
        toggleIcon.classList.add("bi-search");
      }

      document.removeEventListener("click", onDocumentClick);
      document.removeEventListener("keydown", onDocumentKeydown);
      return;
    }

    container.classList.add("d-none");
    container.classList.remove("d-flex");

    toggle.setAttribute("aria-expanded", "false");
    if (toggleIcon) {
      toggleIcon.classList.remove("bi-x-lg");
      toggleIcon.classList.add("bi-search");
    }

    document.removeEventListener("click", onDocumentClick);
    document.removeEventListener("keydown", onDocumentKeydown);
  };

  const onDocumentClick = (e) => {
    if (!form.contains(e.target)) {
      close();
    }
  };

  const onDocumentKeydown = (e) => {
    if (e.key === "Escape") {
      close();
    }
  };

  // Handle form submission
  form.addEventListener("submit", (e) => {
    // If the search input is empty, redirect with from_icon parameter
    if (!input.value || input.value.trim() === "") {
      e.preventDefault();

      const searchUrl = new URL(window.location.origin);
      searchUrl.searchParams.set("s", "");
      searchUrl.searchParams.set("post_type", "product");
      searchUrl.searchParams.set("from_icon", "1");
      nav.go(searchUrl.toString());
    }
  });

  // Mobile: clicking the toggle navigates to the search page
  toggle.addEventListener("click", (e) => {
    if (isDesktop()) return;

    e.preventDefault();
    e.stopPropagation();

    const searchUrl = new URL(window.location.origin);
    searchUrl.searchParams.set("s", "");
    searchUrl.searchParams.set("post_type", "product");
    searchUrl.searchParams.set("from_icon", "1");
    nav.go(searchUrl.toString());
  });

  // Clear input on form submission
  form.addEventListener("submit", () => {
    // Small delay to allow navigation to start before clearing
    setTimeout(() => {
      input.value = "";
    }, 100);
  });

  window.addEventListener("resize", () => {
    // If we resize into desktop, ensure the container is visible.
    if (isDesktop()) {
      close();
      return;
    }

    // Resizing down to mobile should collapse it by default.
    if (isOpen()) {
      close();
    }
  });

  // Clear input if we're on the search results page
  const isSearchPage = window.location.search.includes("s=");

  if (isSearchPage) {
    input.value = "";
  }
}

if (typeof process === "undefined" || process.env.NODE_ENV !== "test") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNavSearch);
  } else {
    initNavSearch();
  }
}

export default { initNavSearch };
